// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-task-title.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($task_id: uuid!, $title: String!) {
  update_tasks_tasks_by_pk(
    pk_columns: { id: $task_id }
    _set: { title: $title }
  ) {
    id
  }
}

`